import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from 'components/PaywayTransactions/List';

export default class PaywayTransactions extends React.Component {
  render = () => {
    const { match } = this.props;
    return (
      <div>
        <Switch>
          <Route exact path='/payway_transactions' component={List}/>
        </Switch>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/PaywayTransactions/index.js